import Cookies from 'js-cookie';

const getGraphqlEndpoint = () => {
  const previewLink = Cookies.get('preview_gateway');
  return previewLink ?? `${location.origin}/graphql`;
};
export default getGraphqlEndpoint;
